module.exports = "https://web-assets.ifttt.com/packs/media/partners/lock-34727d38.svg";